import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "./UserContext";

const WIDGET_SCRIPT_ID = "helpdesk-widget";
const WIDGET_API = process.env.REACT_APP_WIDGET_API_URL || "http://localhost:4000";
const WIDGET_ID = process.env.REACT_APP_WIDGET_ID || "wdgt_vo95yfrbe";
const HIDE_STYLE_ID = "hd-widget-hide-style";

// Widget element IDs rendered by the embed script
const WIDGET_EL_IDS = ["hd-widget-btn", "hd-widget-panel", "hd-toast"];

function injectHideStyle() {
  if (document.getElementById(HIDE_STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = HIDE_STYLE_ID;
  style.textContent = `
    #hd-widget-btn,
    #hd-widget-panel,
    #hd-toast { display: none !important; }
  `;
  document.head.appendChild(style);
}

function removeHideStyle() {
  const style = document.getElementById(HIDE_STYLE_ID);
  if (style) style.remove();
}

function loadWidgetScript() {
  if (document.getElementById(WIDGET_SCRIPT_ID)) return; // already loaded
  const script = document.createElement("script");
  script.id = WIDGET_SCRIPT_ID;
  script.src = `${WIDGET_API}/widget/embed.js`;
  script.setAttribute("data-api", WIDGET_API);
  script.setAttribute("data-widget-id", WIDGET_ID);
  // NOT async — so document.currentScript works correctly in the embed script
  document.body.appendChild(script);
}

const HelpDeskWidget = () => {
  const { user } = useUser();

  // Sync user context to the widget
  useEffect(() => {
    if (user) {
      const context = {
        userId: user.user?.id,
        employeeId: user.id,
        facility: user.facility?.name
      };
      // Set both for maximum compatibility
      window.AlfBossContext = context;
      if (window.AlfBoss) {
        window.AlfBoss.setContext(context);
      }
    }
  }, [user]);

  // Load the script on mount
  useEffect(() => {
    loadWidgetScript();
    removeHideStyle();
  }, []);

  return null;
};

export default HelpDeskWidget;
